import React, { PropTypes } from 'react';

/**
 * Event list counter presentational component
 */
const EventListCounter = ({ count, total }) => (
  <span>
    {count > 0
      ? `Upcoming events (${total})`
      : 'No upcoming events'}
  </span>
);

EventListCounter.propTypes = {
  /**
   * Number of events currently displayed
   */
  count: PropTypes.number.isRequired,
  /**
   * Number of events found on server
   */
  total: PropTypes.number.isRequired,
};

export default EventListCounter;



// WEBPACK FOOTER //
// ./app/src/components/EventListCounter/EventListCounter.react.js